"use client";

import { c as _c } from "react/compiler-runtime";
import { CircularProgress, InputAdornment, TextField, type TextFieldProps } from "@mui/material";
import React, { useEffect, useState } from "react";
type DebouncedInputProps = Omit<TextFieldProps, "onChange"> & {
  value: string;
  onChange: (value: string) => void;
  timeout?: number;
};
export const DebouncedInput: React.FC<DebouncedInputProps> = t0 => {
  const $ = _c(33);
  let InputProps;
  let inputRef;
  let onChange;
  let restProps;
  let timeout;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      timeout,
      InputProps,
      inputRef,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = InputProps;
    $[2] = inputRef;
    $[3] = onChange;
    $[4] = restProps;
    $[5] = timeout;
    $[6] = value;
  } else {
    InputProps = $[1];
    inputRef = $[2];
    onChange = $[3];
    restProps = $[4];
    timeout = $[5];
    value = $[6];
  }
  const [rawInput, setRawInput] = useState(value);
  const [hasPendingChanges, setHasPendingChanges] = useState(false);
  let t1;
  let t2;
  if ($[7] !== value) {
    t1 = () => {
      setRawInput(value);
    };
    t2 = [value];
    $[7] = value;
    $[8] = t1;
    $[9] = t2;
  } else {
    t1 = $[8];
    t2 = $[9];
  }
  useEffect(t1, t2);
  let t3;
  if ($[10] !== onChange || $[11] !== rawInput || $[12] !== timeout || $[13] !== value) {
    t3 = () => {
      const timeoutId = setTimeout(() => {
        setHasPendingChanges(false);
        if (rawInput === value) {
          return;
        }
        onChange(rawInput);
      }, timeout ?? 500);
      return () => {
        clearTimeout(timeoutId);
      };
    };
    $[10] = onChange;
    $[11] = rawInput;
    $[12] = timeout;
    $[13] = value;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== onChange || $[16] !== rawInput || $[17] !== restProps.error || $[18] !== timeout || $[19] !== value) {
    t4 = [onChange, rawInput, restProps.error, timeout, value];
    $[15] = onChange;
    $[16] = rawInput;
    $[17] = restProps.error;
    $[18] = timeout;
    $[19] = value;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  useEffect(t3, t4);
  let t5;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ev => {
      setRawInput(ev.target.value);
      setHasPendingChanges(true);
    };
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const handleChange = t5;
  let t6;
  if ($[22] !== InputProps?.endAdornment || $[23] !== hasPendingChanges) {
    t6 = hasPendingChanges ? <InputAdornment position="end"><CircularProgress size={24} /></InputAdornment> : InputProps?.endAdornment ?? null;
    $[22] = InputProps?.endAdornment;
    $[23] = hasPendingChanges;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== InputProps || $[26] !== t6) {
    t7 = {
      ...InputProps,
      endAdornment: t6
    };
    $[25] = InputProps;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== inputRef || $[29] !== rawInput || $[30] !== restProps || $[31] !== t7) {
    t8 = <TextField value={rawInput} onChange={handleChange} inputRef={inputRef} InputProps={t7} {...restProps} />;
    $[28] = inputRef;
    $[29] = rawInput;
    $[30] = restProps;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
};